import React from 'react';

const Select = ({ label, value, options, onChange }) => (
  <label><span>{label}</span><select value={value} onChange={(event) => onChange(event.target.value)}>
    <option value="">Tous</option>{options.map((option) => <option key={option} value={option}>{option}</option>)}
  </select></label>
);

export default function LdaTreeFilters({ filters, options, onChange }) {
  const change = (key) => (value) => onChange({ ...filters, [key]: value });
  return <div className="lda-tree-filters">
    <label className="lda-tree-filters__search"><span>Rechercher</span><input type="search" value={filters.search}
      placeholder="Nom, code GED, type…" onChange={(event) => change('search')(event.target.value)} /></label>
    <Select label="Phase" value={filters.phase} options={options.phases} onChange={change('phase')} />
    <Select label="Lot" value={filters.lot} options={options.lots} onChange={change('lot')} />
    <Select label="Statut" value={filters.status} options={options.statuses} onChange={change('status')} />
  </div>;
}
